import { clearTokens, queryClient, storage } from '@frontend/shared';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  title: string;
  subtitle?: string;
}

export const Header = ({ title, subtitle }: HeaderProps) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    storage.removeItem('tokens');
    await clearTokens(queryClient);
    navigate('/login', { replace: true });
  };

  return (
    <header className="shrink-0 border-b border-extranet-border bg-extranet-card px-8 py-5 flex items-center justify-between">
      <div>
        <h1 className="text-xl font-semibold tracking-tight text-extranet-text-primary">{title}</h1>
        {subtitle ? <p className="text-extranet-text-secondary text-sm mt-1">{subtitle}</p> : null}
      </div>

      <button
        type="button"
        onClick={handleLogout}
        className="text-sm text-extranet-text-secondary hover:text-extranet-text-primary transition"
      >
        Déconnexion
      </button>
    </header>
  );
};
